// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React, { lazy } from "react";

import { Navigate, Route, Routes } from "react-router-dom";

import { useAuth } from "../../contexts/auth";

const Agreements = lazy(() => import("./agreements"));
const Profile = lazy(() => import("./profile"));
const Questionnaire = lazy(() =>
  import("./your-health/questionnaire/EmbeddedTypeform")
);
const Registration = lazy(() => import("./registration"));
const SignUp = lazy(() => import("./sign-up"));
const YourHealth = lazy(() => import("./your-health"));
const VerifyBirthdate = lazy(() => import("./birthdate"));
const VerifyBirthdateError = lazy(() => import("./birthdate/error"));

export const AuthenticatedUser = () => {
  const { userState } = useAuth();

  return (
    <Routes>
      <Route path="email-verification" element={<SignUp step={2} />} />
      <Route
        path="registration"
        element={userState.registered ? <Navigate to="/" /> : <Registration />}
      />
      <Route path="your-health" element={<YourHealth />} />
      <Route path="your-health/questionnaire" element={<Questionnaire />} />
      <Route
        path="agreements"
        element={
          userState.patientConsent ? <Navigate to="/" /> : <Agreements />
        }
      />
      <Route path="profile/*" element={<Profile />} />
      <Route path="birthdate/error" element={<VerifyBirthdateError />} />
      <Route path="birthdate" element={<VerifyBirthdate />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};
